module.exports = __webpack_public_path__ + "static/media/Laura,35@2x.c3bab829.png";